// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"e4994919","548":"332ae3bb","592":"bf6ca574","828":"f151bb4d"}[chunkId] + ".chunk.js";
};